var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.394h2v2h-2v-2zm0-8h2v6h-2v-6zm.99-5c-5.52 0-9.99 4.48-9.99 10s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10s-4.48-10-10.01-10zm.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
    fill: "#000",
    fillOpacity: 0.87
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNSAxMy4zOTM2SDExLjVWMTUuMzkzNkg5LjVWMTMuMzkzNlpNOS41IDUuMzkzNTVIMTEuNVYxMS4zOTM2SDkuNVY1LjM5MzU1Wk0xMC40OSAwLjM5MzU1NUM0Ljk3IDAuMzkzNTU1IDAuNSA0Ljg3MzU1IDAuNSAxMC4zOTM2QzAuNSAxNS45MTM2IDQuOTcgMjAuMzkzNiAxMC40OSAyMC4zOTM2QzE2LjAyIDIwLjM5MzYgMjAuNSAxNS45MTM2IDIwLjUgMTAuMzkzNkMyMC41IDQuODczNTUgMTYuMDIgMC4zOTM1NTUgMTAuNDkgMC4zOTM1NTVaTTEwLjUgMTguMzkzNkM2LjA4IDE4LjM5MzYgMi41IDE0LjgxMzYgMi41IDEwLjM5MzZDMi41IDUuOTczNTUgNi4wOCAyLjM5MzU1IDEwLjUgMi4zOTM1NUMxNC45MiAyLjM5MzU1IDE4LjUgNS45NzM1NSAxOC41IDEwLjM5MzZDMTguNSAxNC44MTM2IDE0LjkyIDE4LjM5MzYgMTAuNSAxOC4zOTM2WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC44NyIvPgo8L3N2Zz4K";
export { SvgExclamationMark as ReactComponent };